/**
 * 获取当前日期，yyyymmddHis
 * @returns
 */
function getCurrentTime () {
    const now = new Date()
    const year = now.getFullYear() // 年
    const month = ('0' + (now.getMonth() + 1)).slice(-2) // 月，注意JavaScript中getMonth()返回的是0-11，所以需要加1
    const date = ('0' + now.getDate()).slice(-2) // 日
    const hours = ('0' + now.getHours()).slice(-2) // 时
    const minutes = ('0' + now.getMinutes()).slice(-2) // 分
    const seconds = ('0' + now.getSeconds()).slice(-2) // 秒

    // 拼接成字符串形式如：20240309143000
    const formattedTime = `${year}${month}${date}${hours}${minutes}${seconds}`

    return formattedTime
}

function getCurrentDate () {
    const now = new Date()
    const year = now.getFullYear()
    const month = String(now.getMonth() + 1).padStart(2, '0')
    const day = String(now.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
}

export default {
    getCurrentTime,
    getCurrentDate
}
